import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";
import TemplateRow from "./TemplateRow";
import ListItemSkeleton from "./ListItemSkeleton";
import { StorageNotificationTemplate } from "../typeConfig";
import { useStyles } from "./styles";

type Props = {
  template?: StorageNotificationTemplate;
  togglingDefault: boolean;
  settingNewDefault: boolean;
  showDivider: boolean;
  onDelete: (template: StorageNotificationTemplate) => void;
  onToggleDefault: (id: string, isCurrentDefault: boolean) => void;
};

export default function DefaultTemplateSection({
  template,
  togglingDefault,
  settingNewDefault,
  showDivider,
  onDelete,
  onToggleDefault,
}: Props) {
  const { t } = useTranslation("storage");
  const classes = useStyles();

  return (
    <div
      className={
        showDivider ? classes.defaultSection : classes.defaultSectionNoDivider
      }
    >
      <Typography
        variant="caption"
        color="textSecondary"
        className={classes.defaultSectionLabel}
      >
        {t("notificationTemplates.list.defaultLabel")}
      </Typography>
      <div className={classes.defaultSectionContent}>
        {settingNewDefault ? (
          <ListItemSkeleton items={1} />
        ) : template ? (
          <TemplateRow
            template={template}
            togglingDefault={togglingDefault}
            onDelete={onDelete}
            onToggleDefault={onToggleDefault}
          />
        ) : (
          <div className={classes.noDefault}>
            <Typography variant="body2" color="textSecondary">
              {t("notificationTemplates.list.noDefault")}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}
